import { Outlet, useNavigate } from 'react-router-dom';
import { TopBar } from '../pages/components/TopBar/TopBar';
import { AppHeader } from '../pages/components/AppHeader/AppHeader';
import { LandingFooter } from '../pages/components/LandingFooter/LandingFooter';
import { useAuth } from '../hooks/useAuth/useAuth';
import styles from './layout.module.scss';

function Layout() {
  const auth = useAuth();
  const navigate = useNavigate();
  const loggedIn = auth?.isAuthenticated ?? false;

  return (
    <div className={styles.wrapper}>
      <TopBar variant={loggedIn ? 'logado' : 'deslogado'} />
      <AppHeader
        onLogin={() => navigate('/login')}
        onLogout={() => navigate('/logout')}
      />
      <main className={styles.content}>
        <Outlet />
      </main>
      <LandingFooter />
    </div>
  );
}

export default Layout;
